export default {
    userInfo: null,// 用户信息
    family:null,
    token:null,
    zd:{},
}


// WEBPACK FOOTER //
// ./src/vuex/state/state.js